import React from "react";
import Adminnav from "../components/Adminnav";
import Layout from "../components/Layout";

import "../assets/css/Adminpannel.scss";

const Adminpannel = () => {
  return (
    <Layout>
      <Adminnav adminNav="active" />
      <div className="admin_container">
        <h4>This is admin pannel</h4>
        <p>
          Where you can see all users, products and orders and can perform
          operations such as create, update and delete.
        </p>
      </div>
    </Layout>
  );
};

export default Adminpannel;
